import misRutas from 'vue-routes-generator'
import GestionUsuariosComponent from './App'

export default {
	install: Vue => {
		misRutas.route('/main').child('panel-control').child('usuarios', {
			name: 'Gestión de usuarios',
			component: GestionUsuariosComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-usuarios/vue/index.js